import { assetUrl } from '@Shared/Helpers/Utilities';

export const FOOTER_LINKS = {
    legals: {
        title: 'Legals',
        links: [
            { text: 'General terms of service', url: route('web.pages.general-terms') },
            { text: 'Privacy policy', url: route('web.pages.privacy') },
            { text: 'Website terms of use', url: route('web.pages.website-terms') },
            { text: 'California privacy notice', url: route('web.pages.california-privacy') },
            { text: 'Data processing addendum', url: route('web.pages.data-processing') },
        ],
    },
    product: {
        title: 'Product',
        links: [
            { text: 'Our Software', url: route('web.pages.our_software') },
            { text: 'Integrations', url: route('web.integrations.index') },
            { text: 'Rewards', url: route('web.pages.rewards') },
            {
                text: 'API Docs',
                newTab: true,
                url: 'https://developers.referral-factory.com/',
                external: true,
            },
            {
                text: 'Help Guide',
                newTab: true,
                url: 'https://help.referral-factory.com/en/',
                external: true,
            },
            { text: 'Contact', url: route('web.pages.contact') },
            {
                text: __('Log into your account'),
                url: route('customer.auth.login'),
            },
        ],
    },
    tools: {
        title: 'Tools and resources',
        links: [
            { text: 'Calculate your referral rate', url: route('web.pages.calculator') },
            {
                text: 'Free referral link generator',
                url: route('web.pages.create-a-referral-program'),
            },
            { text: 'Referral program examples', url: route('web.pages.campaign_examples') },
            { text: 'Success stories & benchmarks', url: route('web.pages.success_stories') },
            {
                text: 'Referral marketing statistics',
                url: route('web.pages.marketing_statistics'),
            },
            {
                text: 'What is referral marketing software?',
                url: route('web.pages.marketing_software'),
            },
            { text: 'Referral tracking', url: route('web.pages.features') },
        ],
    },

    competitors: {
        title: 'Software comparisons',
        links: [
            {
                text: 'Referral Factory VS Rewardful',
                url: route('web.competitors.rewardful'),
            },
            {
                text: 'Referral Factory VS MentionMe',
                url: route('web.competitors.mentionMe'),
            },
            {
                text: 'Referral Factory VS Referral Rock',
                url: route('web.competitors.referralRock'),
            },
            {
                text: 'Referral Factory VS Viral Loops',
                url: route('web.competitors.viralLoops'),
            },
        ],
    },
    competitors2: {
        title: 'Software comparisons 2',
        links: [
            {
                text: 'Referral Factory VS GrowSurf',
                url: route('web.competitors.growSurf'),
            },
            {
                text: 'Referral Factory VS Referral Candy',
                url: route('web.competitors.referralCandy'),
            },
            {
                text: 'Referral Factory VS Referral Hero',
                url: route('web.competitors.referralHero'),
            },
            {
                text: 'Referral Factory VS Refersion',
                url: route('web.competitors.refersion'),
            },
        ],
    },

    find_us: {
        title: 'Find us',
        links: [
            {
                external: true,
                newTab: true,
                text: 'Amsterdam, Netherlands.',
                url: 'https://maps.app.goo.gl/SjXvDM2hmqoK4mZR8',
            },
        ],
    },
    affiliates: {
        title: 'For affiliates',
        links: [
            {
                text: __('Join our affiliate program '),
                newTab: true,
                url: import.meta.env.VITE_MAIN_CAMPAIGN_URL,
                external: true,
            },
            {
                text: __('Affiliate app (iOS)'),
                newTab: true,
                url: 'https://apps.apple.com/am/app/referral-factory/id6737059474',
                external: true,
            },
            {
                text: __('Affiliate app (Android)'),
                newTab: true,
                url: 'https://play.google.com/store/apps/details?id=com.referralfactory.app',
                external: true,
            },
        ],
    },
};

export const SOCIALS = [
    {
        img: assetUrl('/assets/images/svg/web/socials/youtube.svg'),
        url: 'https://www.youtube.com/@ReferralFactory',
        alt: 'YouTube',
        newTab: true,
        external: true,
    },
    {
        img: assetUrl('/assets/images/svg/web/socials/linkedin.svg'),
        url: 'https://www.linkedin.com/company/referral-factory',
        alt: 'Linkedin',
        newTab: true,
        external: true,
    },
    {
        img: assetUrl('/assets/images/svg/web/socials/x.svg'),
        url: 'https://x.com/referralfctry',
        alt: 'X',
        newTab: true,
        external: true,
    },
    {
        img: assetUrl('/assets/images/svg/web/socials/facebook.svg'),
        url: 'https://www.facebook.com/profile.php?id=100066766689339',
        alt: 'Facebook',
    },
];
